import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-city-evaluation',
  templateUrl: './city-evaluation.component.html',
  styleUrls: ['./city-evaluation.component.scss']
})
export class CityEvaluationComponent implements OnInit {

  public city = history.state.city;
  public country = history.state.country;
  public description = history.state.description;
  public email = history.state.email;
  public video = history.state.video;
  disableFlag: boolean = false;

  constructor(private router: Router, private keycloak: KeycloakService) { }

  ngOnInit(): void {
    this.keycloak.isLoggedIn().then(res => {
      if (res == true) {
        this.disableFlag = true;
      }
      else {
        this.disableFlag = false;
      }
    })
  }

  onActions() {
    this.router.navigateByUrl(`${this.city}/Evaluation/Actions`, { state: { city: this.city, country: this.country } });
  }

  onKPIs() {
    this.router.navigateByUrl(`${this.city}/KPIs`, { state: { city: this.city, country: this.country } });
  }

  onFormative() {
    this.router.navigateByUrl(`${this.city}/Formative-Evaluation`, { state: { city: this.city, country: this.country } });
  }

  goToDna() {
    this.router.navigateByUrl(`${this.city}/ID`, { state: { city: this.city, country: this.country } });
  }

  onImpacts() {
    this.router.navigateByUrl(`${this.city}/Fusilli-Impacts`, { state: { city: this.city, country: this.country } });
  }
}
